import styled from "styled-components";
import {Grid, Typography} from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;

export const NoContentSign = styled(Typography)`
    padding: 16px;
    margin-top: 16px;
    font-style: italic;
    color: gray;
`;
